module.exports = __webpack_public_path__ + "static/media/tringal.892c185e.png";